import { MagneticCta } from '../components/MagneticCta';
import { siteConfig } from '../../../shared/config/site';

export function VisitSection() {
  return (
    <section id="visit" className="defer-render relative bg-white py-[var(--section-padding-y)]" aria-labelledby="visit-heading">
      <div className="mx-auto grid max-w-[var(--container-max)] grid-cols-1 gap-12 px-[var(--section-padding-x)] lg:grid-cols-[1fr_1.05fr] lg:gap-16">
        <div>
          <p className="section-eyebrow">Find us</p>
          <h2 id="visit-heading" className="section-title">
            Pitzer Road, Glen Austin
          </h2>
          <p className="section-copy max-w-lg">
            Find the clinic at 154 Pitzer Rd when you need a consult, a vaccine, or calm hands for a nervous pet.
          </p>

          <dl className="mt-10 space-y-7 font-body text-neutral-600">
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Address</dt>
              <dd className="mt-2 text-lg text-ink">{siteConfig.addressLine}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Phone</dt>
              <dd className="mt-2 space-y-1">
                <a href={siteConfig.phoneHref} className="inline-flex min-h-11 items-center text-lg text-primary-700 transition-colors duration-200 ease-in-out hover:text-primary-600">
                  {siteConfig.phoneDisplay}
                </a>
                <a href={siteConfig.altPhoneHref} className="inline-flex min-h-11 items-center text-base text-primary-700 transition-colors duration-200 ease-in-out hover:text-primary-600">
                  {siteConfig.altPhoneDisplay}
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Email</dt>
              <dd className="mt-2">
                <a href={siteConfig.emailHref} className="inline-flex min-h-11 items-center text-lg text-primary-700 transition-colors duration-200 ease-in-out hover:text-primary-600">
                  {siteConfig.email}
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.25em] text-neutral-500">Hours</dt>
              <dd className="mt-2 text-lg text-ink">{siteConfig.hoursNote}</dd>
            </div>
          </dl>

          <div className="mt-10 flex flex-wrap gap-3">
            <MagneticCta href={siteConfig.phoneHref} variant="primary">
              Call the clinic
            </MagneticCta>
            <MagneticCta href={siteConfig.mapsUrl} variant="ghost">
              Open in Google Maps
            </MagneticCta>
          </div>

          <div className="mt-10 border border-urgent/25 bg-[#fbf4f1] p-6">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-urgent-ink">Emergency mobile</p>
            <a
              href={siteConfig.emergencyHref}
              className="mt-3 inline-flex min-h-11 items-center font-display text-2xl font-semibold text-ink transition-colors duration-200 ease-in-out hover:text-urgent-ink"
            >
              {siteConfig.emergencyDisplay}
            </a>
            <p className="mt-2 max-w-[38ch] font-body text-base leading-6 text-neutral-600">
              Use this line when something feels wrong outside normal hours.
            </p>
          </div>
        </div>

        <div className="relative min-h-[320px] overflow-hidden bg-stage lg:min-h-full">
          <iframe
            title="Halfway House Veterinary Clinic on Google Maps"
            src={siteConfig.mapsEmbedUrl}
            className="absolute inset-0 h-full w-full border-0 grayscale-[20%] contrast-[1.05]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10" />
        </div>
      </div>
    </section>
  );
}
